import { ClosedReason, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestPreviewsQueryKey, bondRequestsQueryKey } from "../bond-request.keys";
import { invalidateBondRequestIfClosed, redirectToIssuedBond } from "../utils";

export const useCloseBondRequest = (accountId: SuretyAccountId, quoteId: SuretyQuoteId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationFn: async ({
			closedReason,
			note,
		}: {
			closedReason: ClosedReason;
			note?: string;
			onSuccess?: () => void;
		}) =>
			await post(
				`/v2/surety/accounts/${accountId}/quotes/${quoteId}/close`,
				{
					closedReason,
					note,
				},
				"none",
			),
		onSuccess: (_, { onSuccess }) => {
			void queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(quoteId) });
			void queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() });
			if (onSuccess) {
				onSuccess();
			}
		},
		onSettled: invalidateBondRequestIfClosed(queryClient, quoteId),
	});

	return {
		closeBondRequest: mutation.mutate,
		closeBondRequestLoading: mutation.isPending,
		closeBondRequestError: mutation.error,
		dismissCloseBondRequestError: () => {
			mutation.reset();
		},
	};
};
